<div class="file_input" [ngClass]="{icon_on_top: topicon}">
	<label [ngClass]="{TextLeft: file_name && !topicon, empty: !file_name}"
		appDragNdrop
		(filesChangeEmiter)="onDropHandler($event)" 
		(filesInvalidEmiter)="onInvalidDropHandler($event)" 
		[allowed_extensions]="allowed_extensions"
		[multiple]="multiple">
		<input #myInput type="file" (change)="onChangeHandler($event)" accept="{{accepted_input_extensions}}" [multiple]="multiple" [required]="required">
		{{(file_name ? file_name : placeholder) | translate}} <br>
		<span class="accepted">
			{{accepted}}
		</span>
		<span class="icon"></span>
	</label>
</div>